const KEY = "ecoach_attribution";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];

export const captureAttribution = () => {
  const qs = new URLSearchParams(window.location.search);
  const found = {};
  PARAMS.forEach((p) => {
    const v = qs.get(p);
    if (v) found[p] = v;
  });
  if (!Object.keys(found).length) return;
  localStorage.setItem(KEY, JSON.stringify({ ...found, landing_page: window.location.pathname }));
};

export const getAttribution = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const clearAttribution = () => localStorage.removeItem(KEY);